import React from "react";
import Typography from '@mui/material/Typography';

const Contact = () => {
    return (
        <Typography>
            Contact Us
        </Typography>
    );
  };

  export default Contact;